import { render, staticRenderFns } from "./UserManual.vue?vue&type=template&id=73252163&scoped=true&"
import script from "./UserManual.vue?vue&type=script&lang=js&"
export * from "./UserManual.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73252163",
  null
  
)

export default component.exports